import { http } from '../../core/services/http';
import transformLoadUsers from './transformLoadUsers';

export const loadUsers = (vendorId: number) =>
  http.get(`/vendors/${vendorId}/users`).then(response => transformLoadUsers(response.data));

export const loadUserById = (vendorId: number, userId?: number | string) =>
  http.get(`/vendors/${vendorId}/users/${userId}`).then(response => response.data);
